import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SelectItem, ConfirmationService } from 'primeng/api';
import moment from 'moment';

import { RequisitionDataService } from '../../../data-services/requisition.service';
import { RequisitionDto } from '../../../models/requisition-dto';
import { LocalRequistionService } from '../../../data-services/local-requisition.service';
import { CodeDescription } from '../../../models/code-description-dto';
import { Gender } from '../../../models/gender';
import { Race } from '../../../models/race';
import { Ethnicity } from '../../../models/ethnicity';
import { LookupService } from '../../../data-services/lookup.service';
import { FacilityDataService } from '../../../data-services/facility.service';
import { FacilityDto } from '../../../models/facility-dto';
import { ProviderDataService } from '../../../data-services/provider.service';
import { ProviderSearchDto } from '../../../models/provider-search-dto';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { KENDO_DATEINPUTS } from "@progress/kendo-angular-dateinputs";
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { ReactiveFormsModule } from '@angular/forms'; // Import ReactiveFormsModule

@Component({
  selector: 'app-receiving-edit-requisition',
  templateUrl: './receiving-edit-requisition.component.html',
  styleUrls: ['./receiving-edit-requisition.component.css'],
  providers: [MessageService, ConfirmationService],
  imports: [Dialog, FormsModule, CommonModule, KENDO_DATEINPUTS, KENDO_DROPDOWNS, ReactiveFormsModule]
})
export class ReceivingEditRequisitionComponent implements OnInit {
  @Input() editMode: string;
  @Input() packageDeliveredDate: string;
  @Output() onSampleUpdated = new EventEmitter<any>();
  @Output() updateDone = new EventEmitter<any>();
  @Output() updateFailed = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<any>();

  constructor(public localReqService: LocalRequistionService,
    private formBuilder: UntypedFormBuilder,
    private requisitionDataService: RequisitionDataService,
    private providerService: ProviderDataService,
    private facilityService: FacilityDataService,
    private lookupService: LookupService) {
  }

  loading: boolean = false;
  showProviderSearch: boolean = false;
  requisition: RequisitionDto;
  requisitionEditForm: UntypedFormGroup;
  providerSearchFirstName: String = "";
  providerSearchLastName: String = "";
  providerSearchNPI: String = "";
  npi: number;
  newProvider: ProviderSearchDto;

  minColldate: Date;
  minColldateFormatted: string;
  packageDeliveredDateFormatted: string;
  packageDelDate: Date;

  rejectionTypes: SelectItem[] = [];
  genderList: CodeDescription[] = [];
  raceList: CodeDescription[] = [];
  ethnicityList: CodeDescription[] = [];
  gender: Gender;
  race: Race;
  ethnicity: Ethnicity;
  states: SelectItem[];
  minbdate: Date;
  maxbdate: Date;
  formattedminbdate: string;
  formattedmaxbdate: string;

  facilityList: FacilityDto[] = [];
  facilityListFiltered: FacilityDto[] = [];
  providerSearch: any = {
    FirstName: "",
    LastName: "",
    NPI: ""
  };

  providerSearchList: ProviderSearchDto[] = [];
  providerSearchDto: ProviderSearchDto;
  showProvidersList = false;
  newProviderNPI: number = 0;

  displayResultsMessage = false;


  ngOnInit() {
    this.lookupService.getStates().subscribe((data: any) => {
      this.states = data.map(d => <SelectItem>{ label: d.Description, value: d.Code });
    });
    this.providerSearch = {};
    this.providerSearch.FirstName = "";
    this.providerSearch.LastName = "";
    this.providerSearch.NPI = "";

    this.requisition = this.localReqService.getRequisition();
    this.minbdate = new Date();
    this.minbdate.setFullYear(this.minbdate.getFullYear() - 120);
    this.formattedminbdate = moment(this.minbdate).format('MM/DD/YYYY')
    this.maxbdate = new Date();
    this.formattedmaxbdate = moment(this.maxbdate).format('MM/DD/YYYY')

    this.gender = new Gender();
    this.genderList = this.gender.getGenderListing();

    this.race = new Race();
    this.raceList = this.race.getRaceListing();

    this.ethnicity = new Ethnicity();
    this.ethnicityList = this.ethnicity.getEthnicityListing();

    this.minColldate = new Date();
    this.minColldate.setFullYear(this.minColldate.getFullYear() - 1);
    this.minColldateFormatted = moment(this.minColldate).format('MM/DD/YYYY hh:mm A')
    this.packageDelDate = new Date(this.packageDeliveredDate);
    this.packageDeliveredDateFormatted = moment(this.packageDelDate).format('MM/DD/YYYY hh:mm A');

    this.facilityService.getFacilities().subscribe((data: any) => {
      this.facilityList = data;
      this.facilityListFiltered = this.facilityList;
      this.requisitionEditForm.get('facility').setValue(this.requisition.FacilityCode);
    });


    this.requisitionEditForm = this.formBuilder.group({
      firstName: ['', [Validators.required, this.nowhitespace]],
      lastName: ['', [Validators.required, this.nowhitespace]],
      birthDate: ['', [Validators.required, this.checkMinBirthDate(), this.checkMaxBirthDate()]],
      gender: [''],
      race: [''],
      ethnicity: [''],
      address1: ['', [Validators.required, this.nowhitespace]],
      address2: ['', [this.nowhitespace]],
      city: ['', [Validators.required, this.nowhitespace]],
      state: ['', [Validators.required, this.nowhitespace]],
      zip: ['', [Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]],
      phone: [''],
      email: ['', [Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"), this.nowhitespace]],

      collectiondate: ['', [Validators.required, this.checkMinDate(), this.checkMaxDate()]],
      collectedby: ['', [Validators.required, this.nowhitespace]],

      facility: [''],
      providerName: [''],
      providerFirstName: [''],
      providerLastName: [''],
      providerNPI: ['']
    });

    this.requisitionEditForm.get('firstName').setValue(this.requisition.FirstName);
    this.requisitionEditForm.get('lastName').setValue(this.requisition.LastName);

    let birthdate = this.requisition.BirthDate == null ? null : this.requisition.BirthDate;
    let bdate: Date = null;
    if (birthdate !== null) {
      bdate = moment(birthdate).toDate();
      this.requisitionEditForm.get('birthDate').setValue(bdate);
    } else {
      this.requisitionEditForm.get('birthDate').setValue("");
    }
    this.requisitionEditForm.get('gender').setValue(this.requisition.Gender);
    this.requisitionEditForm.get('race').setValue(this.requisition.Race);
    this.requisitionEditForm.get('ethnicity').setValue(this.requisition.Ethnicity);
    this.requisitionEditForm.get('address1').setValue(this.requisition.Address1);
    this.requisitionEditForm.get('address2').setValue(this.requisition.Address2);
    this.requisitionEditForm.get('city').setValue(this.requisition.City);
    this.requisitionEditForm.get('state').setValue(this.requisition.State);
    this.requisitionEditForm.get('zip').setValue(this.requisition.Zip);
    this.requisitionEditForm.get('phone').setValue(this.requisition.Phone);
    this.requisitionEditForm.get('email').setValue(this.requisition.Email);


    let collectiondate = this.requisition.DateOfService;
    if (collectiondate !== null && collectiondate !== undefined) {
      let coldate = moment(collectiondate).toDate();
      this.requisitionEditForm.get('collectiondate').setValue(coldate);
    } else {
      this.requisitionEditForm.get('collectiondate').setValue(null);
    }
    this.requisitionEditForm.get('collectedby').setValue(this.requisition.SpecimenCollectedBy);

    this.requisitionEditForm.get('providerName').setValue(this.requisition.ProviderName + " " + this.requisition.ProviderNPI);
    this.npi = this.requisition.ProviderNPI;

  }

  updateRequisition() {
    this.loading = true;
    this.fillRequisitionParameters();
    this.requisitionDataService.updateRequisition(this.requisition).subscribe((data: any) => {
      this.loading = false;
      this.requisition.Id = data;
      console.log('requisition save completed', data);
      this.updateDone.emit();
    },
      err => {
        this.loading = false;
        console.log("Error On Update Requisition :" + err.message);
        this.updateFailed.emit(err.error.ExceptionMessage);
      },
    );
  }

  fillRequisitionParameters() {
    this.requisition.FirstName = this.requisitionEditForm.get('firstName').value;
    this.requisition.LastName = this.requisitionEditForm.get('lastName').value;
    this.requisition.BirthDate = this.requisitionEditForm.get('birthDate').value;
    this.requisition.Gender = this.requisitionEditForm.get('gender').value;
    this.requisition.Race = this.requisitionEditForm.get('race').value;
    this.requisition.Ethnicity = this.requisitionEditForm.get('ethnicity').value;
    this.requisition.Address1 = this.requisitionEditForm.get('address1').value;
    this.requisition.Address2 = this.requisitionEditForm.get('address2').value;
    this.requisition.City = this.requisitionEditForm.get('city').value;
    this.requisition.State = this.requisitionEditForm.get('state').value;
    this.requisition.Zip = this.requisitionEditForm.get('zip').value;
    this.requisition.Phone = this.requisitionEditForm.get('phone').value;
    this.requisition.Email = this.requisitionEditForm.get('email').value;

    this.requisition.SpecimenCollectedBy = this.requisitionEditForm.get('collectedby').value;
    this.requisition.DateOfService = this.requisitionEditForm.get('collectiondate').value;
    this.requisition.DateOfService = moment(this.requisition.DateOfService).format('MM/DD/YYYY hh:mm a');

    this.requisition.FacilityCode = this.requisitionEditForm.get('facility').value;
    let facilityDto: FacilityDto = this.facilityList.find(x => x.FacilityCode === this.requisition.FacilityCode);
    if (facilityDto !== null) {
      this.requisition.ClientId = facilityDto.ClientId;
    }


    if (this.newProvider && this.newProvider.NPI && this.newProvider.NPI != this.requisition.ProviderNPI) {
      this.requisition.ProviderNPI = this.newProvider.NPI;
      this.requisition.ProviderName = this.newProvider.PhysicianFirstName + ' ' + this.newProvider.PhysicianLastName;
    }

  }

  nowhitespace(control: AbstractControl): ValidationErrors | null {
    let str = control.value as string;
    if (str === null) return null;
    if (str.length >= 0 && str.startsWith(' ')) {
      return { nowhitespace: true }
    }
    return null;
  }

  checkMinDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value < this.minColldate) {
        return { minDate: true };
      } else return null;
    }
  }
  checkMaxDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value > this.packageDelDate) {
        return { maxDate: true };
      } else return null;
    }
  }

  checkMinBirthDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value < this.minbdate) {
        return { minBirthDate: true };
      } else return null;
    }
  }

  checkMaxBirthDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value > this.maxbdate) {
        return { maxBirthDate: true };
      } else return null;
    }
  }

  changeProvider() {
    this.npi = +this.newProviderNPI;
    this.newProvider = this.providerSearchList.find(x => x.NPI === this.npi);
    this.requisitionEditForm.get("providerName").setValue(this.newProvider.PhysicianFirstName + " " + this.newProvider.PhysicianLastName + " " + this.newProvider.NPI);
    this.requisitionEditForm.get("providerName").markAsDirty();
    this.closeProviderSearch();
  }

  closeProviderSearch() {
    this.newProviderNPI = 0;
    this.providerSearchList = [];
    this.providerSearch.FirstName = "";
    this.providerSearch.LastName = "";
    this.providerSearch.NPI = null;
    this.showProviderSearch = false;
  }


  searchProvider() {
    if (this.providerSearch.FirstName === '' && this.providerSearch.LastName === '' && this.providerSearch.NPI === '')
      return;
    this.loading = true;
    this.providerSearchList = [];
    if (this.providerSearch.FirstName || this.providerSearch.LastName) {
      this.providerService.searchMedTek21ProvidersByName(this.providerSearch.FirstName, this.providerSearch.LastName).subscribe((data: any) => {
        this.loading = false;
        if (data !== null && data.length > 0) {
          this.displayResultsMessage = false;
          this.showProvidersList = true;
          this.providerSearchList = data;
          this.providerSearchList = this.providerSearchList.map(x => {
            return <ProviderSearchDto>{
              NPI: x.NPI,
              PhysicianFirstName: x.PhysicianFirstName,
              PhysicianMiddleName: x.PhysicianMiddleName,
              PhysicianLastName: x.PhysicianLastName,
              PhysicianCredentials: x.PhysicianCredentials,
              PhysicianName: x.NPI + ' ' + x.PhysicianFirstName + ' ' + x.PhysicianLastName,
              PhysicianAddress1: x.PhysicianAddress1,
              PhysicianAddress2: x.PhysicianAddress2,
              PhysicianCity: x.PhysicianCity,
              PhysicianState: x.PhysicianState,
              PhysicianZip: x.PhysicianZip
            }
          })
        } else {
          this.showProvidersList = false;
          this.displayResultsMessage = true;
        }
      },
        err => {
          this.loading = false;
          this.displayResultsMessage = true;
          this.showProvidersList = false;
          console.log("Error Search By Name :" + err.message);
        },
      );
    } else if (this.providerSearch.NPI) {
      this.providerService.searchMedTek21ProviderByNPI(this.providerSearch.NPI).subscribe((data: any) => {
        this.loading = false;
        this.providerSearchDto = data;
        if (this.providerSearchDto.NPI > 0) {
          this.displayResultsMessage = false;
          this.showProvidersList = true;
          this.providerSearchList.push(this.providerSearchDto);
          console.log("PROVIDER DTO ", this.providerSearchDto);
        } else {
          this.displayResultsMessage = true;
          this.showProvidersList = false;
        }
      },
        err => {
          this.loading = false;
          this.displayResultsMessage = true;
          console.log("Error On Search by NPI :" + err.message);
        },
      );
    } else {
      return;
    }
  }

  public facilityFilterChange(filter: string): void {
    console.log("FITLER = ", filter);
    if (filter === '' || filter === null) {
      this.facilityListFiltered = this.facilityList;
      return;
    }
    this.facilityListFiltered = this.facilityList.filter(
      (s) => {
        if (s.FacilityCode !== null) {
          return s.FacilityName.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
        }
      }
    );
  }

  clear() {
    this.requisitionEditForm.get('providerFirstName').setValue('');
    this.requisitionEditForm.get('providerLastName').setValue('');
    this.requisitionEditForm.get('providerNPI').setValue('');
    this.providerSearchList = [];
    this.showProvidersList = false;
    this.displayResultsMessage = false;
  }

  handleBirthDateChange(event) {
    console.log('CAL ', event);
  }


  cancel() {
    this.cancelled.emit();
  }

  ngOnDestroy() {
  }
}
